"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _semanticUiReact = require("semantic-ui-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EditableInfoCard = function EditableInfoCard(props) {
  var editable = props.editable,
    data = props.data,
    isLoaded = props.isLoaded,
    editCardData = props.editCardData,
    isUserAuthorized = props.isUserAuthorized;
  return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Segment, null, isLoaded ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    className: "summary-card",
    verticalAlign: "middle"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _lodash.default.map(data, function (carditem, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      mobile: 8,
      computer: carditem.width
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-content ".concat(carditem.label)
    }, /*#__PURE__*/_react.default.createElement("strong", null, carditem.label), /*#__PURE__*/_react.default.createElement("br", null), carditem.value ? carditem.value : '--')));
  }), editable && isUserAuthorized && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    mobile: 2,
    computer: 2,
    floated: "right",
    textAlign: "right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-action"
  }, /*#__PURE__*/_react.default.createElement("a", {
    id: "edit-action",
    href: "#",
    onClick: editCardData,
    title: "edit"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
    link: true,
    name: "pencil"
  }), "Edit")))))) : /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
    inline: "centered",
    active: true
  }, "Loading..."));
};
var _default = EditableInfoCard;
exports.default = _default;